import React from "react";
import LegalPage from "./LegalPage";
import data from "@content/legal/terms.json";

const TermsAndConditions = () => (
    <LegalPage
        slug="terms-and-conditions"
        data={data}
        crumbLabel="Terms & Conditions"
    />
);

export default TermsAndConditions;
